// extracted by mini-css-extract-plugin
module.exports = {"list":"DeskOccupiedPeriods_list__3WEuJ","name":"DeskOccupiedPeriods_name__b9JzN"};